import type { ReactNode } from 'react';
import { IconX } from '@tabler/icons-react';
import { useT } from '@hana/i18n';
import s from './kit.module.css';

export type Tone = 'neutral' | 'info' | 'ok' | 'warn' | 'err';

/** Chip: trạng thái (chấm màu) · loại hàng / meta (icon + giá trị ngắn, nhãn đủ khi rê chuột qua `label`). */
export function Chip({
  tone = 'neutral',
  dot,
  icon,
  label,
  children,
  onRemove,
}: {
  tone?: Tone;
  /** màu chấm trạng thái, vd 'var(--d-amber)' */
  dot?: string;
  icon?: ReactNode;
  /** nhãn đầy đủ: hiện khi rê chuột và đọc cho trình đọc màn hình */
  label?: string;
  children: ReactNode;
  onRemove?: () => void;
}) {
  const tr = useT();
  return (
    <span className={`${s.chip} ${s[`t-${tone}`]}`} title={label} role={label ? 'group' : undefined} aria-label={label ? `${label}: ${textOf(children)}` : undefined}>
      {dot && <span className={s.dot} style={{ background: dot }} aria-hidden="true" />}
      {icon}
      {children}
      {onRemove && (
        <button type="button" className={s.chipX} aria-label={tr('ui.remove', { label: label ?? textOf(children) })} onClick={onRemove}>
          <IconX size={13} stroke={2.2} aria-hidden="true" />
        </button>
      )}
    </span>
  );
}

function textOf(n: ReactNode): string {
  return typeof n === 'string' || typeof n === 'number' ? String(n) : '';
}
